<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, te } = useI18n()

const model = defineModel()

const {
  field,
  options,
  placeholder = 'Vali hinnang',
  maxSelectedLabels = 2,
  selectionLimit = 2,
  size = 'small',
  class: className,
  tooltipPosition = 'left',
} = defineProps({
  field: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  placeholder: String,
  maxSelectedLabels: Number,
  selectionLimit: Number,
  size: String,
  class: String,
  tooltipPosition: {
    type: String,
    default: 'left',
    validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value),
  },
})

const ratingOptions = computed(() => {
  return options.map(optionValue => {
    const descriptionKey = `messages.rating.${field}.descriptions.${optionValue}`
    return {
      value: optionValue,
      label: t(`messages.rating.${field}.${optionValue}`),
      description: te(descriptionKey) ? t(descriptionKey) : null,
    }
  })
})

// Colours and size come from the global tooltip style (app.js); only the
// width is local.
const tooltipTextStyle = computed(() => (tooltipPosition === 'left' ? 'w-40' : 'w-64'))
</script>

<template>
  <MultiSelect
    v-model="model"
    :options="ratingOptions"
    optionLabel="label"
    optionValue="value"
    :placeholder="placeholder"
    :maxSelectedLabels="maxSelectedLabels"
    :selectionLimit="selectionLimit"
    :size="size"
    :class="class"
    fluid
  >
    <template #option="slotProps">
      <div class="flex items-center justify-between w-full">
        <div class="flex flex-col justify-center gap-1">
          <span>{{ slotProps.option.label }}</span>
        </div>
        <span
          v-if="slotProps.option.description"
          class="pi pi-question-circle text-blue-500"
          v-tooltip.[tooltipPosition]="{
            value: slotProps.option.description,
            pt: { text: tooltipTextStyle }
          }"
        >
        </span>
      </div>
    </template>
  </MultiSelect>
</template>
